import { render, staticRenderFns } from "./SKDataTableEditable.vue?vue&type=template&id=9baf1b54&"
import script from "./SKDataTableEditable.vue?vue&type=script&lang=js&"
export * from "./SKDataTableEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports